import { ensurePluginQueryData } from '@app/common/queries/plugins';
export function pluginPageResolver(hashedId) {
    return ensurePluginQueryData(decodeURIComponent(hashedId));
}
